import axios from  'axios'
//const baseURL= "http://3.109.148.179/padmahandler/api/"

//const baseURL= "http://3.109.148.179/padmaapitesting/api/"

 const baseURL= "http://targetdemo.asktek.net/target.bms.inspection.webapi/api/"
//const baseURL = "http://localhost:8082/api/"

const instance = axios.create({
    baseURL
    
})
export default  {
  instance ,
  baseURL
}
